module.exports = __webpack_public_path__ + "img/consult.9569c642.png";